import React from 'react'

export function DriverInfoReviewSection({ title, children }) {
  return (
    <React.Fragment>
      <h2>{title}</h2>
      <ul>
        {children}
      </ul>
    </React.Fragment>
  )
}

export function DriverInfoReviewSectionItem({ label, value, onEditClick }) {
  return (
    <li className="d-flex align-items-center">
      <span className="mr-auto"><b>{label}:</b> <span className="text-uppercase p-2">{value}</span></span>
      {onEditClick && <div onClick={onEditClick}><img src={require("../../../assets/images/ico-edit.png")} alt="" /></div>}
    </li>
  )
}